import { isPresent, isDefined } from "@grandvisionhq/utils";
import { mapServerToVariantBase } from "./map-server-to-variant-base.js";
import { getSolutionsProductFeatures } from "../../../../utils/product-feature-mappers/mappers/server-to-client/utils/product-feature-mappers/get-solutions-product-features.js";
import { mapServerToSolutionsSpecifications } from "../../../../specification-mappers/mappers/server-to-client/specification-mappers/map-server-to-solutions-specifications.js";
const mapServerToSolutionsVariant = (serverProduct, slug, locale, priceSegmentChannelKey) => {
  const { variants: serverVariants } = serverProduct;
  if (!serverVariants || !serverVariants.length) {
    return;
  }
  const clientVariants = serverVariants.map((serverVariant) => {
    const variantBase = mapServerToVariantBase(
      serverVariant,
      serverProduct,
      slug,
      locale,
      priceSegmentChannelKey
    );
    if (!variantBase) return;
    const {
      contactLensCareType,
      targetUsers,
      convenience,
      keyInstructions,
      subscriptionIntervals,
      packageOption
    } = serverVariant.variantTypeDetails;
    const productFeatures = getSolutionsProductFeatures(serverVariant.variantTypeDetails);
    const specifications = mapServerToSolutionsSpecifications(serverVariant, serverProduct.brand);
    const detailsList = [targetUsers, convenience, keyInstructions].filter(isPresent).filter((item) => item !== "");
    const solution = {
      ...variantBase,
      variantType: "solutions",
      facets: {
        packageOption: packageOption ?? void 0
      },
      productFeatures,
      specifications,
      detailsList,
      contactLensCareType: contactLensCareType ?? void 0,
      availableSubscriptionIntervals: subscriptionIntervals
    };
    return solution;
  });
  return clientVariants.filter(isDefined);
};
export {
  mapServerToSolutionsVariant
};
//# sourceMappingURL=map-server-to-solutions-variant.js.map
